import { app } from '../../../app';

app.factory('PublicServices', PublicServices);

/** @ngInject */
function PublicServices($http) {

    return {
        getAllPublicServicesThatSupportSSO: getAllPublicServicesThatSupportSSO,
        getAllPublicServicesThatSupportSSOFiltered: getAllPublicServicesThatSupportSSOFiltered,
        getAllPublicServicesThatSupportSSOAnd2FAFiltered: getAllPublicServicesThatSupportSSOAnd2FAFiltered
    };

    function getAllPublicServicesThatSupportSSO() {
        return $http.get('app/rest/public_services/ssosupported')
            .then(response => response.data);
    }
    
    function getAllPublicServicesThatSupportSSOFiltered() {
        return $http.get('app/rest/public_services/ssosupportedfiltered')
            .then(response => response.data);
    }
    
    function getAllPublicServicesThatSupportSSOAnd2FAFiltered() {
        return $http.get('app/rest/public_services/ssoand2fasupported')
            .then(response => response.data);
    }
    
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/public-services.service.js